import {PayloadItemModel} from '../../../../../../../../core';

export class DeletePayload extends PayloadItemModel<{ id: number }> {
}
